var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import { Reflection } from 'path-shared/services/reflection/reflection';
import { DatePipe } from '@angular/common';
import * as i0 from "@angular/core";
var defaultSortParam = 'data';
var defaultSortDirection = 'desc';
var DeltacarHistoricoFilterService = /** @class */ (function (_super) {
    __extends(DeltacarHistoricoFilterService, _super);
    function DeltacarHistoricoFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeltacarHistoricoFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        var datepipe = new DatePipe('es-ES');
        return new HttpParams()
            .append('matricula', filter.matricula ? filter.matricula : '')
            .append('dataInici', Reflection.empty(filter.dataInici) ? null : datepipe.transform(filter.dataInici, 'yyyyMMdd'))
            .append('dataFi', Reflection.empty(filter.dataFi) ? null : datepipe.transform(filter.dataFi, 'yyyyMMdd'))
            .append('estado', filter.estado)
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    DeltacarHistoricoFilterService.prototype.createLoadParams = function (content) {
        return new HttpParams()
            .append('content', content ? content : '');
    };
    DeltacarHistoricoFilterService.ngInjectableDef = i0.defineInjectable({ factory: function DeltacarHistoricoFilterService_Factory() { return new DeltacarHistoricoFilterService(); }, token: DeltacarHistoricoFilterService, providedIn: "root" });
    return DeltacarHistoricoFilterService;
}(CustomFilterService));
export { DeltacarHistoricoFilterService };
